export default function(text) {
  const template = document.createElement("template")
  template.innerHTML = text
  return template.content.firstElementChild
}
